import {Route, Routes, Outlet, Navigate} from 'react-router-dom'
import {PageLink, PageTitle} from '../../../../_metronic/layout/core'
import {ContentsListWrapper} from './contents-list/ContentsList'

const contentsBreadcrumbs: Array<PageLink> = [
  {
    title: 'Content Management',
    path: '/apps/content-management/contents',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

const ContentsPage = () => {
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          path='contents'
          element={
            <>
              <PageTitle breadcrumbs={contentsBreadcrumbs}>Contents list</PageTitle>
              <ContentsListWrapper />
            </>
          }
        />
      </Route>
      <Route index element={<Navigate to='/apps/content-management/contents' />} />
    </Routes>
  )
}

export default ContentsPage
